export { default as DepositPage } from './submodules/Deposit';
export { default as WithdrawalPage } from './submodules/Withdrawal';
export type { PaymentType } from 'app/modules/Payment/data';
